import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Country } from '../models/country.model';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';

@Injectable()
export class CountryService {
  private baseUrl: string; // = "https://localhost:44353/api/officesetup";
  private api: string = "api/Country";
  

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
  }

  private handleErrors(errorResponse: HttpErrorResponse) {
    if (errorResponse.error instanceof ErrorEvent) {
      console.error('Country Service Client Side Error: ', errorResponse.error.message);
    } else {
      console.error('Country Service Server Side Error: ', errorResponse);
    }

    return throwError("There is a problem with the service. We are notified & working on it. Please try again later.");
  }

  getCountryList(encryptedUser: string): Observable<Country[]> {
    return this.httpClient
      .get<Country[]>(this.baseUrl, {
        headers: new HttpHeaders({
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp(), catchError(err => { return this._utilityService.handleErrors(err, null, "", "CountryService", "getCountryList"); }));
  }
}
